import { Component, Inject, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import {
  MatFormField,
  MatHint,
  MatInput,
  MatLabel,
} from '@angular/material/input';
import { CalendarItemType } from '../../../services/calendar/calendar.service';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-create-calendar-item-dialog',
  templateUrl: './create-calendar-item-dialog.component.html',
  styleUrls: ['./create-calendar-item-dialog.component.css'],
  standalone: true,
  imports: [
    MatInput,
    FormsModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatButton,
    MatHint,
    MatSelectModule,
  ],
})
export class CreateCalendarItemDialogComponent {
  public readonly CalendarItemType = CalendarItemType;
  public type: CalendarItemType = CalendarItemType.DenyDate;
  public description: string = '';

  readonly dialogRef = inject(MatDialogRef<CreateCalendarItemDialogComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: { date: Date }) {}
}
